import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/api";

export const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_URL()}
    target="_blank" rel="noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 w-13 h-13 p-4 rounded-full bg-white text-black shadow-[0_8px_40px_rgba(255,255,255,0.15)] hover:scale-110 transition-transform duration-300 flex items-center justify-center"
  >
    <MessageCircle size={22} />
  </a>
);
